/**
 * Firebase Cloud Messaging service worker bootstrap
 *
 * Registers the service worker used by FCM on the web. This should not run
 * inside native WebViews (Android/iOS) as they do not support service workers.
 */

import { devLog } from './env';

/** Register the Firebase Cloud Messaging service worker on supported browsers. */
export function registerFCMServiceWorker() {
  devLog('[FCM] Registering service worker...');
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', { scope: '/' })
    .then((registration) => {
      devLog('[FCM] SW registered. Scope:', registration.scope);

      // Log when a new SW is found and installed while an existing one controls the page.
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            devLog('[FCM] New service worker installed (update available).');
          }
        });
      });

      // Optional: observe controller changes
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        devLog('[FCM] Service worker controller changed.');
      });
    })
    .catch((error) => {
      console.error('[FCM] Service worker registration failed:', error);
    });
}

